/**
 * Created by Kotkin on 18.07.2017.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Bem from 'bemHelper';
import formatDate from 'helpers/formatDate';
import { authConnect } from 'auth';
import Perms from 'auth/perms';
import { Thumb } from 'components/image';
import Icon, { iconTypes } from 'components/icon';
import Link from 'components/link';

import linksBackOffice from 'src-sites/backoffice/links';

const bemClasses = new Bem('cardInfoContainer');

@authConnect()
export default class CardInfoContainer extends PureComponent {
  static propTypes = {
    checkPermission: PropTypes.func,
    userPhoto: PropTypes.any, // eslint-disable-line
    userName: PropTypes.string,
    userId: PropTypes.number,
    data: PropTypes.array // eslint-disable-line
  };

  render() {
    const {
      checkPermission, userPhoto, userName, userId = {}, data = []
    } = this.props;
    const profile = data[0];

    return (
      <div {...bemClasses()}>
        <div {...bemClasses('imgContainer')}>
          <div {...bemClasses('img')}>
            {userPhoto ?
              <Thumb
                {...bemClasses('imgPic')}
                image={userPhoto}
              /> :
              <Icon {...bemClasses('icon')} type={iconTypes.personCircle} />
            }
          </div>
          <div {...bemClasses('views')}>
            <span {...bemClasses('text')}>Просмотров визитки: {get(profile, 'profile_views', 0)}</span>
          </div>
        </div>
        <div {...bemClasses('imgException')}>
          <div {...bemClasses('top')}>
            <div {...bemClasses('topContent')}>
              <div {...bemClasses('userName')}>
                <span {...bemClasses('text')} children={userName || get(profile, 'forum_nick')} />
              </div>
            </div>
          </div>
          {checkPermission(Perms.FORUM_CONTROL_ALL_TOPIC) &&
            <div {...bemClasses('item')}>
              <span {...bemClasses('text')}>ID:&nbsp;</span>
              <span {...bemClasses('text')}>
                <Link
                  {...bemClasses('link')}
                  builder={linksBackOffice.sectionUserIdEditor}
                  builderProps={{
                    user_id: this.props.userId,
                    tree: profile.tree,
                    title: 'Профиль'
                  }}
                  external
                  blank
                >
                  <span {...bemClasses('linkContent')}>
                    <span {...bemClasses('text')} children={userId} />
                  </span>
                </Link>
              </span>
            </div>
          }
          <div {...bemClasses('item')}>
            <span {...bemClasses('text')} children={get(profile, 'user_rank.name')} />
          </div>
          <div {...bemClasses('item')}>
            <span {...bemClasses('text')}>Зарегистрирован:&nbsp;</span>
            <span {...bemClasses('text')}>
              {formatDate({
                date: profile.date_add,
                render: 'date',
                format: 'dd.mm.yyyy'
              })}
            </span>
          </div>
          <div {...bemClasses('item')}>
            <span {...bemClasses('text')}>Откуда:&nbsp;</span>
            <span {...bemClasses('text')} children="Страна, город" />
          </div>
        </div>
      </div>
    );
  }
}
